/**
 * Must match backend SIMPLE_JWT.ACCESS_TOKEN_LIFETIME (core/settings.py).
 * Used for token_expiry and proactive refresh interval.
 */
export const ACCESS_TOKEN_LIFETIME_MINUTES = 15;

/** Refresh shortly before expiry; 1 minute buffer. */
export const TOKEN_EXPIRY_BUFFER_MINUTES = 1;

/** Minutes from "now" to store as token_expiry (backend expiry minus buffer). */
export const TOKEN_EXPIRY_MINUTES = ACCESS_TOKEN_LIFETIME_MINUTES - TOKEN_EXPIRY_BUFFER_MINUTES;

/** Proactive refresh interval (refresh well before 15 min so one missed tick doesn't cause logout). */
export const REFRESH_INTERVAL_MINUTES = 10;

export const REFRESH_INTERVAL_MS = REFRESH_INTERVAL_MINUTES * 60 * 1000;
